export { default as generateCardIcon } from './generateCardIcon';
